import React from 'react'

const HomeLatestService = () => {
  return (
    <>
    <>
  {/* Tpm Latest Service Area Start */}
  <section className="latest-service-area tmp-section-gapTop">
    <div className="container">
      <div className="section-head mb--50">
        <div className="section-sub-title center-title tmp-scroll-trigger tmp-fade-in animation-order-1">
          <span className="subtitle">Our Latest Services</span>
        </div>
        <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2">
          Inspiring Businesses Through Every Project We Deliver
          <br />
        </h2>
        <p className="description section-sm tmp-scroll-trigger tmp-fade-in animation-order-3">
          {" "}
          We provide expert business consulting and digital solutions designed to improve performance, efficiency, and organizational growth. From creative strategy to execution, we transform ideas into impactful results.{" "}
        </p>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-1">
            <h2 className="service-card-num">
              <span>01.</span>Creative Solutions Portfolio
            </h2>
            <p className="service-para">
              Explore how our consulting services and digital innovations help businesses overcome challenges, streamline operations, and achieve sustainable growth.
            </p>
          </div>
          <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-2">
            <h2 className="service-card-num">
              <span>02.</span>Innovation-Led Project Delivery
            </h2>
            <p className="service-para">
              We believe that smart design, strategic thinking, and the right technology can empower brands and transform their digital presence across industries.
            </p>
          </div>
          <div className="service-card-v2 tmponhover tmp-scroll-trigger tmp-fade-in animation-order-3">
            <h2 className="service-card-num">
              <span>03.</span>Featured Project Showcase
            </h2>
            <p className="service-para">
              Browse a curated selection of successful projects—from responsive web design and custom software to cross-platform apps and digital strategy implementation.
            </p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="service-card-user-image">
            <img
              className="tmp-scroll-trigger tmp-zoom-in animation-order-1"
              src="assets/images/services/latest-services-user-image.png"
              alt="latest-user-image"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Tpm Latest Service Area End */}
</>

    </>
  )
}

export default HomeLatestService